export class Domain {
    value: string;
    name: string;
    translation: string;
    order: number;
}
